export function getLocale(): string {
  return window.__LOCALE__ || 'en';
}
